import { render, staticRenderFns } from "./ed-tree-node.vue?vue&type=template&id=590ef09a&scoped=true&"
import script from "./ed-tree-node.ts?vue&type=script&lang=ts&"
export * from "./ed-tree-node.ts?vue&type=script&lang=ts&"
import style0 from "./ed-tree-node.scss?vue&type=style&index=0&id=590ef09a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590ef09a",
  null
  
)

export default component.exports